import { useContext } from "react";
import { DocumentContext } from "../utils/document-provider";

export const useDocument = () => {
  const context = useContext(DocumentContext);
  if (!context) {
    throw new Error("useDocument must be used within a DocumentProvider");
  }
  return context;
};

// True when the document cannot be edited: it is void, or it
// is deleted
export const useDocumentReadOnly = (): boolean => {
  const [state, , , , , , , , , , , , , isReadOnly] = useDocument();
  return Boolean(state?.documentDetailsData?.is_void || isReadOnly);
};
